/* ck-core.js — Grok 50 Greenfield
 * Single owner: vehicle cookies, cascade, options resolve, cart, family data.
 * No DOM.
 */
(function () {
  'use strict';

  var API = '/apps/coverking-api/Shop/';
  var COOKIE_MS = 259200000; 
  var KEYS = ['vehicle_year','vehicle_make','vehicle_model','vehicle_submodel',
    'vehicle_details','vehicle_details_display','vehicle_base_vehicle'];

  function trim(s) { return (s == null ? '' : String(s)).trim(); }
  function money(cents) {
    if (cents == null) return '';
    return '$' + (cents / 100).toFixed(2);
  }
  function toCents(price) {
    if (price == null) return null;
    if (typeof price === 'number') return Math.round(price);
    var s = String(price).trim();
    if (s.indexOf('.') > -1) return Math.round(parseFloat(s) * 100);
    var n = parseInt(s, 10);
    return isNaN(n) ? null : n;
  }
  function CKError(code, message, detail) {
    this.name = 'CKError'; this.code = code;
    this.message = message || code; this.detail = detail || null;
  }
  CKError.prototype = Object.create(Error.prototype);

  function getJson(url, signal) {
    return fetch(url, { credentials: 'same-origin', signal: signal }).then(function (r) {
      if (!r.ok) throw new CKError('HTTP_' + r.status, url + ' ' + r.status);
      return r.json();
    });
  }
  function ssGet(k) {
    try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function ssSet(k, v) {
    try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }

  
  function getCookie(name) {
    try {
      var m = (document.cookie || '').match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      if (!m) return '';
      return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim();
    } catch (e) { return ''; }
  }
  function setCookie(name, value) {
    var exp = new Date(Date.now() + COOKIE_MS).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp + '; path=/';
  }
  function delCookie(name) {
    document.cookie = name + '=; Max-Age=0; path=/';
  }
  function isValidDisplay(s) {
    if (!s) return false;
    var t = String(s).trim().toLowerCase();
    if (!t) return false;
    return ['your vehicle','undefined','null','false','select vehicle','choose vehicle'].indexOf(t) < 0;
  }
  function getVehicle() {
    var y = getCookie('vehicle_year'), m = getCookie('vehicle_make'), d = getCookie('vehicle_model');
    if (!y || !m || !d) return null;
    var sm = getCookie('vehicle_submodel');
    var base = getCookie('vehicle_base_vehicle');
    var details = getCookie('vehicle_details') || (y + ' ' + m + ' ' + d);
    var display = getCookie('vehicle_details_display') || (details + (sm ? ' ' + sm : ''));
    return {
      year: y, make: m, model: d, submodel: sm, baseVehicle: base,
      details: details, display: display
    };
  }
  function emitVehicle(v) {
    try { document.dispatchEvent(new CustomEvent('ck:vehicle-changed', { detail: { vehicle: v || null } })); } catch (e) {}
  }
  function setVehicle(v) {
    if (!v) return clearVehicle();
    var y = trim(v.year), m = trim(v.make), d = trim(v.model), sm = trim(v.submodel);
    var base = trim(v.baseVehicle || v.base_vehicle);
    setCookie('vehicle_year', y);
    setCookie('vehicle_make', m);
    setCookie('vehicle_model', d);
    setCookie('vehicle_submodel', sm);
    if (base) setCookie('vehicle_base_vehicle', base);
    else delCookie('vehicle_base_vehicle');
    var details = y + ' ' + m + ' ' + d;
    setCookie('vehicle_details', details);
    setCookie('vehicle_details_display', details + (sm ? ' ' + sm : ''));
    var out = getVehicle();
    emitVehicle(out);
    return out;
  }
  function clearVehicle() {
    KEYS.forEach(delCookie);
    ['mainMaterial','productID','mcat'].forEach(delCookie);
    try { localStorage.removeItem('productID4'); } catch (e) {}
    emitVehicle(null);
  }

  
  var memCascade = {};
  function cascadeOk(d) {
    if (!d || typeof d !== 'object') return false;
    if (Array.isArray(d)) return d.length > 0;
    for (var k in d) {
      var v = d[k];
      if (Array.isArray(v) && v.length) return true;
      if (/base.?vehicle/i.test(k) && v) return true;
    }
    return false;
  }
  function cascade(path, signal) {
    var hit = memCascade[path] || ssGet('ckc:' + path);
    if (hit && cascadeOk(hit)) { memCascade[path] = hit; return Promise.resolve(hit); }
    return getJson(API + path, signal).then(function (data) {
      if (cascadeOk(data)) { memCascade[path] = data; ssSet('ckc:' + path, data); }
      return data;
    });
  }
  function asList(d, key) {
    var a = (d && (d[key] || d[key.toLowerCase()])) || (Array.isArray(d) ? d : []);
    if (!Array.isArray(a)) a = [];
    return a.map(function (x) {
      if (x == null) return '';
      if (typeof x === 'string' || typeof x === 'number') return String(x);
      return String(x.Year || x.Make || x.Model || x.year || x.make || x.model || x.Name || x.name || x);
    }).filter(Boolean);
  }
  function getYears(signal) {
    return cascade('Years', signal).then(function (d) { return asList(d, 'Years'); });
  }
  function getMakes(year, signal) {
    return cascade('Makes?year=' + encodeURIComponent(year), signal).then(function (d) { return asList(d, 'Makes'); });
  }
  function getModels(year, make, signal) {
    return cascade('Models?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make), signal)
      .then(function (d) { return asList(d, 'Models'); });
  }
  function getSubmodels(year, make, model, signal) {
    var q = 'Submodel?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make) + '&model=' + encodeURIComponent(model);
    return cascade(q, signal).then(function (d) {
      
      var base = trim((d && (d.Base_Vehicle || d.baseVehicle || d.BaseVehicle || d.base_vehicle)) || '');
      var list = (d && (d.Sub_Models || d.subModels || d.SubModels || d.submodels)) || [];
      if (!Array.isArray(list)) list = [];
      return {
        baseVehicle: base,
        subModels: list.map(function (x) {
          if (typeof x === 'string') return x;
          return String(x.Submodel || x.submodel || x.Name || x.name || x);
        })
      };
    });
  }

  
  var memProduct = {};
  function slimProduct(p) {
    return {
      id: p.id, handle: p.handle, title: p.title, tags: p.tags || [],
      options: (p.options || []).map(function (o) {
        return typeof o === 'string' ? o : { name: o.name, position: o.position, values: o.values };
      }),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id, title: v.title, available: v.available !== false,
          price: toCents(v.price), option1: v.option1, option2: v.option2, option3: v.option3
        };
      })
    };
  }
  function getProductJson(handle, signal) {
    handle = trim(handle);
    if (!handle || handle === 'mainMaterial' || handle === 'undefined') {
      return Promise.reject(new CKError('BAD_HANDLE', 'bad handle ' + handle));
    }
    if (memProduct[handle]) return Promise.resolve(memProduct[handle]);
    var ss = ssGet('ckc:prod:' + handle);
    if (ss) { memProduct[handle] = ss; return Promise.resolve(ss); }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return getJson(root + 'products/' + handle + '.js', signal)
      .then(function (p) {
        var s = slimProduct(p); memProduct[handle] = s; ssSet('ckc:prod:' + handle, s); return s;
      })
      .catch(function () {
        return getJson(root + 'products/' + handle + '.json', signal).then(function (wrap) {
          var s = slimProduct(wrap.product || wrap);
          memProduct[handle] = s; ssSet('ckc:prod:' + handle, s); return s;
        });
      });
  }

  
  function fetchOptions(vehicle, ctx, signal) {
    ctx = ctx || {};
    var qs = [
      'year=' + encodeURIComponent(vehicle.year || ''),
      'make=' + encodeURIComponent(vehicle.make || ''),
      'model=' + encodeURIComponent(vehicle.model || ''),
      'submodel=' + encodeURIComponent(vehicle.submodel || ''),
      'baseVehicle=' + encodeURIComponent(vehicle.baseVehicle || ''),
      'onlymat=' + encodeURIComponent(ctx.onlymat || ''),
      'nomat=' + encodeURIComponent(ctx.nomat || ''),
      'productId=' + encodeURIComponent(ctx.productId || ''),
      'mcat=' + encodeURIComponent(ctx.mcat || '')
    ].join('&');
    return getJson(API + 'Options?' + qs, signal).then(function (d) { return d || {}; });
  }
  function reportMissingPattern(lead) {
    lead = lead || {};
    var email = trim(lead.email), pid = trim(lead.productId);
    if (!email) return Promise.reject(new CKError('WAITLIST_EMAIL', 'email required'));
    if (!pid) return Promise.reject(new CKError('WAITLIST_NO_PRODUCT', 'product required'));
    var q = new URLSearchParams({
      Email: email, ProductID: pid,
      Basevehicle: lead.baseVehicle || '', Submodel: lead.submodel || '',
      URL: lead.url || '', mcat: lead.mcat || '',
      comment: trim(lead.comment) || pid
    });
    return getJson(API + 'Customer_Missing_Pattern?' + q).then(function (d) {
      if (!d || !d.success) throw new CKError('WAITLIST_FAILED', (d && d.messages) || 'could not send', d);
      return d;
    });
  }

  function optionIs(product, index, name) {
    var o = product.options && product.options[index];
    var n = o && (o.name || o);
    return trim(n).toLowerCase() === name;
  }
  
  function candidates(product, row) {
    var pid = trim(row.ProductID), pos = trim(row.Position);
    var posAxis = optionIs(product, 0, 'position');
    var byId = [], byPos = [];
    product.variants.forEach(function (v) {
      if (pid && trim(v.option1) === pid) byId.push(v);
      else if (pos && trim(v.title) === pos) byPos.push(v);
      else if (pos && posAxis && trim(v.option1) === pos) byPos.push(v);
    });
    return byId.length ? byId : byPos;
  }
  function pickExactlyOne(list, ctx) {
    if (!list.length) throw new CKError('VARIANT_UNMATCHED', 'no variant', ctx);
    if (list.length === 1) return list[0];
    throw new CKError('VARIANT_AMBIGUOUS', list.length + ' variants matched', ctx);
  }
  function axisOfOption2(v) { return trim(v) === '2-tone' ? '2-tone' : 'solid'; }
  
  function axisOfColorName(name) {
    var n = String(name || '').replace(/\u00A0/g, ' ').toLowerCase();
    if (/(^|[^0-9])2[\s-]?tone\b/.test(n) || /\b(w\/|with)\s+black\s+sides\b/.test(n)) return '2-tone';
    return 'solid';
  }
  function packV(v, extra) {
    var o = { variantId: v.variantId != null ? v.variantId : v.id, price: v.price, title: v.title, available: v.available };
    if (extra) Object.keys(extra).forEach(function (k) { o[k] = extra[k]; });
    return o;
  }
  function axisMap(variants, clsOrList) {
    var by = {}, list = Array.isArray(clsOrList) ? clsOrList : null;
    var cls = list ? null : clsOrList;
    (list || variants).forEach(function (cand) {
      if (cls != null && trim(cand.option1) !== trim(cls)) return;
      var k = axisOfOption2(cand.option2);
      if (!by[k]) by[k] = packV(cand);
    });
    return by;
  }
  function resolveCarCoverVariant(product, row) {
    var list = candidates(product, row);
    if (!list.length) throw new CKError('VARIANT_UNMATCHED', 'no variant', { family: 'car-cover', handle: product.handle, row: row });
    var cls = list[0].option1 || trim(row.ProductID);
    var by = axisMap(product.variants, cls);
    return packV(by.solid || list[0], { classCode: cls, variantsByAxis: by });
  }
  function resolveSeatCoverVariant(product, row) {
    var ctx = { family: 'seat-cover', handle: product.handle, row: row };
    var list = candidates(product, row), pos = trim(row.Position);
    if (list.length === 1) return packV(list[0], { position: row.Position || null });
    var pair = list.length === 2 && optionIs(product, 0, 'position') && optionIs(product, 1, 'tone') &&
      list.every(function (c) { return trim(c.option1) === pos; }) &&
      axisOfOption2(list[0].option2) !== axisOfOption2(list[1].option2);
    if (!pair) return packV(pickExactlyOne(list, ctx), { position: row.Position || null });
    var by = axisMap(null, list);
    return packV(by.solid || by['2-tone'], { position: row.Position || null, variantsByAxis: by });
  }
  function resolveSimpleVariant(product, row, family) {
    var list = candidates(product, row);
    if (!list.length && product.variants.length === 1) list = product.variants.slice();
    var v = pickExactlyOne(list, { family: family, handle: product.handle, row: row });
    return packV(v, {
      classCode: family === 'car-cover' ? (v.option1 || trim(row.ProductID)) : null,
      position: row.Position || null
    });
  }
  function matchVariant(product, row, family) {
    if (family === 'car-cover') return resolveCarCoverVariant(product, row);
    if (family === 'seat-cover') return resolveSeatCoverVariant(product, row);
    return resolveSimpleVariant(product, row, family);
  }
  
  function applyColorPrice(sku, colorName) {
    if (!sku || !sku.variantsByAxis) return sku;
    var axis = axisOfColorName(colorName), hit = sku.variantsByAxis[axis];
    var out = Object.assign({}, sku, { priceAxis: axis });
    if (!hit) {
      out.variantId = null; out.price = null; out.priceText = '';
      out.available = false; out.axisUnresolved = true;
      return out;
    }
    out.variantId = hit.variantId; out.price = hit.price; out.priceText = money(hit.price);
    out.title = hit.title; out.available = hit.available; out.axisUnresolved = false;
    return out;
  }

  /* Global swatch display order — shop metafield custom.swatch_order (JSON array of
     MaterialIDs, best first), bridged by pdp-main.liquid as window.__ckSwatchOrder.
     Anything but a real array (unset -> null, wrong type, absent global) degrades to []
     = today's API order. Unranked IDs sort last, keeping API order (stable sort).
     Reversible: delete SWATCH_ORDER, swatchRank, and the sort line in extractColors. */
  var SWATCH_ORDER = (Array.isArray(window.__ckSwatchOrder) ? window.__ckSwatchOrder : []).map(function (s) { return trim(s).toUpperCase(); }).filter(Boolean);
  function swatchRank(c) { var i = SWATCH_ORDER.indexOf(c.materialId.toUpperCase()); return i < 0 ? SWATCH_ORDER.length : i; }

  function extractColors(oj) {
    var out = [], seen = {};
    function push(name, url, mid) {
      name = trim(name); if (!name) return;
      var k = name.toLowerCase(); if (seen[k]) return; seen[k] = 1;
      out.push({
        id: k.replace(/[^a-z0-9]+/g, '-'),
        name: name, swatchUrl: url || '', materialId: trim(mid)
      });
    }
    var lists = oj.Material_Category_Img_Lists;
    if (lists && Array.isArray(lists.Swatches)) {
      lists.Swatches.forEach(function (s) {
        if (!s) return;
        push(s.Material_Name || s.Name || s.name, s.Image_URL || s.Image || s.img, s.MaterialID);
      });
    }
    if (SWATCH_ORDER.length) out.sort(function (a, b) { return swatchRank(a) - swatchRank(b); });
    return out;
  }

  var MULTILINE = { 'seat-cover': 1, 'floor-mat': 1 };
  var memResolve = {};

  function resolve(vehicle, materialHandle, family, ctx) {
    ctx = ctx || {};
    var signal = ctx.signal;
    if (!vehicle) return Promise.reject(new CKError('NO_VEHICLE', 'vehicle required'));
    if (!family) return Promise.reject(new CKError('BAD_FAMILY', 'family required'));

    var ensure = trim(vehicle.baseVehicle)
      ? Promise.resolve(vehicle)
      : getSubmodels(vehicle.year, vehicle.make, vehicle.model, signal).then(function (sm) {
          if (sm && sm.baseVehicle) {
            vehicle = Object.assign({}, vehicle, { baseVehicle: sm.baseVehicle });
            try { setVehicle(Object.assign({}, getVehicle() || vehicle, { baseVehicle: sm.baseVehicle })); } catch (e) {}
          }
          return vehicle;
        });

    return ensure.then(function (veh) {
      vehicle = veh;
      if (!trim(vehicle.baseVehicle)) {
        return Promise.reject(new CKError('NO_BASE_VEHICLE', 'baseVehicle unresolved', { vehicle: vehicle }));
      }
      var key = [family, materialHandle, vehicle.baseVehicle, vehicle.submodel,
        vehicle.year, vehicle.make, vehicle.model,
        ctx.onlymat || '', ctx.nomat || '', ctx.productId || '', ctx.mcat || ''].join('|');
      if (memResolve[key]) return Promise.resolve(memResolve[key]);

      return fetchOptions(vehicle, {
        onlymat: ctx.onlymat || '', nomat: ctx.nomat || '',
        productId: ctx.productId || '', mcat: ctx.mcat || ''
      }, signal).then(function (oj) {
        var rows = Array.isArray(oj.Option_Generated) ? oj.Option_Generated : [];
        if (!rows.length) {
          return {
            family: family, materialHandle: materialHandle, vehicle: vehicle,
            positions: [], colors: [], skuIndex: [], video: oj.Video || null,
            error: new CKError('OPTIONS_EMPTY', 'no fitment for this vehicle'),
            select: function () { return []; },
            configsFor: function () { return []; }
          };
        }
        var colors = extractColors(oj);
        var handles = {};
        rows.forEach(function (r) {
          var h = trim(r.ProductHandle || r.product_handle || materialHandle);
          if (h) handles[h] = 1;
        });
        var hList = Object.keys(handles);
        if (!hList.length) hList = [materialHandle];
        var errors = [];

        return Promise.all(hList.map(function (h) {
          return getProductJson(h, signal).then(function (p) { return { h: h, p: p }; })
            .catch(function (e) { errors.push(e); return null; });
        })).then(function (loaded) {
          var byH = {};
          loaded.forEach(function (x) { if (x) byH[x.h] = x.p; });
          var skuIndex = [], positions = [], posSeen = {};

          rows.forEach(function (row) {
            var h = trim(row.ProductHandle || row.product_handle || materialHandle);
            var product = byH[h];
            if (!product) { errors.push(new CKError('PRODUCT_FETCH_FAILED', h)); return; }
            var resolved;
            try { resolved = matchVariant(product, row, family); }
            catch (e) { errors.push(e); return; }

            var rawPos = trim(row.Position);
            if (!rawPos && MULTILINE[family]) {
              errors.push(new CKError('VARIANT_UNMATCHED', 'blank Position', { family: family, row: row }));
              return;
            }
            var posLabel = rawPos || 'Default';
            var optionsDescr = trim(row.Options_Descr);
            var rid = row.recid != null ? row.recid : row.Recid;

            if (!posSeen[posLabel]) {
              posSeen[posLabel] = 1;
              positions.push({ position: posLabel, productId: trim(row.ProductID), configs: [] });
            }
            var posEntry = null;
            for (var i = 0; i < positions.length; i++) {
              if (positions[i].position === posLabel) { posEntry = positions[i]; break; }
            }
            if (posEntry && !posEntry.configs.some(function (c) { return c.recid === rid; })) {
              var pid = trim(row.ProductID);
              posEntry.configs.push({
                recid: rid,
                optionsDescr: optionsDescr || (pid ? 'Config ' + pid : 'Config ' + String(rid)),
                productId: pid,
                lineArt: trim(row.LineArt_URL || row.lineArt_url || '')
              });
            }
            skuIndex.push({
              recid: rid, position: posLabel, optionsDescr: optionsDescr,
              materialName: trim(row.Material_Name), materialId: trim(row.MaterialID),
              variantId: resolved.variantId, price: resolved.price,
              priceText: money(resolved.price), available: resolved.available,
              classCode: resolved.classCode || null,
              variantsByAxis: resolved.variantsByAxis || null,
              colors: null
            });
          });
          skuIndex.forEach(function (s) { s.colors = colors; });

          var result = {
            family: family, materialHandle: materialHandle, vehicle: vehicle,
            positions: positions, colors: colors, skuIndex: skuIndex,
            video: (oj.Video && oj.Video.Link) ? oj.Video : null,
            error: errors.length ? new CKError('PARTIAL', errors.length + ' row(s) failed', { errors: errors }) : null,
            select: function (sel) {
              sel = sel || {};
              return skuIndex.filter(function (s) {
                if (sel.position && trim(s.position) !== trim(sel.position)) return false;
                if (sel.recid != null && String(s.recid) !== String(sel.recid)) return false;
                if (sel.optionsDescr && trim(s.optionsDescr) !== trim(sel.optionsDescr)) return false;
                return true;
              });
            },
            configsFor: function (position) {
              for (var i = 0; i < positions.length; i++) {
                if (trim(positions[i].position) === trim(position)) return positions[i].configs || [];
              }
              return [];
            }
          };
          if (!result.error) memResolve[key] = result;
          return result;
        });
      });
    });
  }

  
  var PROFILES = {
    'car-cover': {
      family: 'car-cover', label: 'Custom Car Cover',
      selectionMode: 'single-line', configAxis: true,
      color: { scope: 'global', required: true },
      cartExtra: function (ctx) {
        return { 'Cover Class': (ctx.sku && ctx.sku.classCode) || '', 'Color': ctx.primaryColor || '' };
      }
    },
    'seat-cover': {
      family: 'seat-cover', label: 'Custom Seat Cover',
      selectionMode: 'multi-line', configAxis: true,
      color: { scope: 'per-position', required: true },
      cartExtra: function (ctx) {
        return {
          'Position': (ctx.sku && ctx.sku.position) || '',
          'Configuration': (ctx.sku && ctx.sku.optionsDescr) || '',
          'Color': ctx.color || ''
        };
      }
    },
    'floor-mat': {
      family: 'floor-mat', label: 'Custom Floor Mat',
      selectionMode: 'multi-line', configAxis: true,
      color: { scope: 'per-position', required: true },
      cartExtra: function (ctx) {
        return {
          'Position': (ctx.sku && ctx.sku.position) || '',
          'Configuration': (ctx.sku && ctx.sku.optionsDescr) || '',
          'Color': ctx.color || ''
        };
      }
    },
    'dash-cover': {
      family: 'dash-cover', label: 'Custom Dash Cover',
      selectionMode: 'single-line', configAxis: true,
      color: { scope: 'global', required: true },
      cartExtra: function (ctx) {
        return { 'Configuration': (ctx.sku && ctx.sku.optionsDescr) || '', 'Color': ctx.primaryColor || '' };
      }
    },
    'sunshield': {
      family: 'sunshield', label: 'Custom Sun Shield',
      selectionMode: 'single-line', configAxis: true,
      color: { scope: 'global', required: false },
      cartExtra: function (ctx) {
        return { 'Configuration': (ctx.sku && ctx.sku.optionsDescr) || '', 'Color': ctx.primaryColor || '' };
      }
    }
  };

  function profile(family) { return PROFILES[family] || null; }

  function baseProps(vehicle, sku, extra, ctx) {
    ctx = ctx || {};
    var materialId = ctx.colorMaterialId || (sku && sku.materialId) || '';
    var materialName = ctx.colorMaterialName || (sku && sku.materialName) || '';
    var p = {
      'Vehicle': vehicle ? (vehicle.display || vehicle.details || '') : '',
      'Material': materialName,
      '_BaseVehicle': (vehicle && vehicle.baseVehicle) || '',
      '_Submodel': (vehicle && vehicle.submodel) || '',
      '_MaterialID': materialId,
      '_Recid': sku && sku.recid != null ? String(sku.recid) : ''
    };
    if (extra) Object.keys(extra).forEach(function (k) { p[k] = extra[k]; });
    if (p.Color && p.Material && String(p.Color).toLowerCase() === String(p.Material).toLowerCase()) {
      delete p.Material;
    }
    return p;
  }

  function cartProperties(family, ctx) {
    var p = profile(family);
    var extra = p && p.cartExtra ? p.cartExtra(ctx) : { 'Color': ctx.primaryColor || ctx.color || '' };
    return baseProps(ctx.vehicle, ctx.sku, extra, ctx);
  }

  function buildCartItems(skus, propsList) {
    return (skus || []).map(function (s, i) {
      var props = Array.isArray(propsList) ? propsList[i] : propsList;
      var clean = {};
      if (props) Object.keys(props).forEach(function (k) {
        if (props[k] != null && props[k] !== '') clean[k] = String(props[k]);
      });
      return { id: s.variantId, quantity: 1, properties: clean };
    });
  }
  function addToCart(skus, propsList, signal, children) {
    var items = buildCartItems(skus, propsList);
    if (!items.length || items.some(function (it) { return !it.id; })) {
      return Promise.reject(new CKError('CART_INVALID', 'missing variant'));
    }
    // Add-ons ride as children of the first cover line, Shopify's own parent_id nesting. On a
    // multi-line product that is the first position the fitment lists: the front row.
    (children || []).forEach(function (c) {
      items.push({ id: c.id, quantity: 1, parent_id: items[0].id, properties: c.properties });
    });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', signal: signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new CKError('CART_ADD_FAILED', (data && (data.description || data.message)) || ('cart/add ' + r.status), data);
        return data;
      });
    });
  }

  var api = {
    API: API, COOKIE_MS: COOKIE_MS, CKError: CKError,
    getCookie: getCookie, getVehicle: getVehicle, setVehicle: setVehicle, clearVehicle: clearVehicle,
    isValidDisplay: isValidDisplay,
    getYears: getYears, getMakes: getMakes, getModels: getModels, getSubmodels: getSubmodels,
    getProductJson: getProductJson, fetchOptions: fetchOptions, reportMissingPattern: reportMissingPattern, resolve: resolve,
    profile: profile, profiles: PROFILES, cartProperties: cartProperties,
    buildCartItems: buildCartItems, addToCart: addToCart, money: money,
    applyColorPrice: applyColorPrice, axisOfColorName: axisOfColorName
  };

  window.CK = api;
})();
